var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("p", [
        _c("strong", [
          _vm._v(_vm._s(_vm.data.start) + " - " + _vm._s(_vm.data.end)),
        ]),
      ]),
      _vm._v(" "),
      _c("pulse-loader", {
        staticClass: "text-center",
        attrs: { loading: _vm.loading, color: _vm.$constants.LOADING_COLOR },
      }),
      _vm._v(" "),
      !_vm.loading && _vm.data.report
        ? [
            _c("p", [
              _vm._v("Всего: "),
              _c("strong", [_vm._v(_vm._s(_vm.data.report.totalOrders))]),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v("Оплачены: "),
              _c("strong", [_vm._v(_vm._s(_vm.data.report.closedOrder.total))]),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v("На сумму: "),
              _c("strong", [
                _vm._v(_vm._s(_vm.data.report.closedOrder.totalSum)),
              ]),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v("Конверсия: "),
              _c("strong", [
                _vm._v(_vm._s(_vm.data.report.closedOrder.conversion) + "%"),
              ]),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v("Средний чек: "),
              _c("strong", [
                _vm._v(_vm._s(_vm.data.report.closedOrder.avaragePrice)),
              ]),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }